import React from "react";
import { Container, Col, Row } from "../../components/grid";
import {
  Paragraph,
  Heading1,
  Heading2,
  Heading3,
  LinkStyled,
  Bold,
} from "../../components/typography";
import { ItemTraverser } from "../../containers/commerce";
import SidemenuLayout from "../../layout/DefaultLayout/Layouts/SidemenuLayout";
import ProductView1 from "../../components/commerce/ProductViews/ProductView1";
import RowProductView from "../../components/grid/RowProductView";

export default () => (
  <SidemenuLayout menuPicker="Fadoel" activeSidemenu="IPA">
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0px">
          <Heading1>IPA - India Pale Ale</Heading1>
        </Col>
        <Col md={12} paddingTop="0px">
          <Paragraph>
            IPA står helt konkret for India Pale Ale og er en lys gylden øl,
            brygget på lyse malte og store mængder humle. IPA har en markant
            bitterhed fra humlen, men ellers en meget frisk og frugtig smag, og
            øllen byder generelt på en højere alkoholprocent sammenlignet med
            almindelig pilsner. Hos Skafte finder du et stort udvalg af skøn IPA
            øl på fad til din næste fest, event eller begivenhed.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser
          category="fadoelIPA"
          filterLiterPrice
          filterFadkobling
          filterLiterSize
          display={ProductView1}
        />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>
            Den historiske IPA, dens karakteristiske smagsnoter og aroma
          </Heading2>
          <Paragraph>
            India Pale Ale (IPA) har sit navn fra dens oprindelseshistorie fra
            det 18. århundrede. Den blev nemlig udviklet af englænderne, med
            henblik på at kunne klare den lange sejltur over havet til de
            indiske kolonier. Det var for varmt at brygge englændernes øl lokalt
            i Indien, men den lange tur og de store temperaturudsving gjorde det
            praktisk talt også umuligt at medbringe øllen hele vejen fra England
            til Indien, uden at den blev dårlig. Dengang kendte man ikke til
            pasteurisering, så man valgte derfor at udvikle en øl med højere
            alkoholprocent og større mængde humle, hvilket var med til at
            konservere øllen bedre, så den kunne klare den lange sejltur på 3 -
            6 måneder. Resultatet blev en IPA.
          </Paragraph>
          <Paragraph>
            IPA øl er en lys ale, der er brygget på lyse malte og med større
            mængder humle, end hvad vi kender det fra klassiske pilsnere.
            Grundet den store mængde humle, vil du opleve en markant bitterhed,
            men samtidig også blive mødt af en frisk og frugtig smag, der ofte
            suppleres af blomstret og til tider urteagtige noter. Da IPA er
            brygget på lys malt, får øllen også en lys og gylden farve, mens
            skummet ofte er hvidt eller cremefarvet og tæt. Den oprindelige IPA
            er engelsk, men de kendte bryggemetoder af IPA øl, som vi kender i
            dag, er ofte den amerikanske fortolkning, hvor der anvendes endnu
            større mængder humle.
          </Paragraph>
          <Paragraph>
            Bestil din IPA øl på fad fra Skafte. Vi tilbyder også{" "}
            <LinkStyled to="/fadoelsanlaeg">leje af fadølsanlæg</LinkStyled>{" "}
            samt levering, opsætning og returtagning af både udstyr og fustager.
            Du har også mulighed for at hente din IPA på vores lager i Brøndby.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>IPA øl på fad: stort udvalg af flere varianter</Heading2>
          <Paragraph>
            Her på siden finder du et bredt udvalg af forskellige IPA øl på fad,
            der med garanti bliver et hit til din fest, event eller begivenhed.
            IPA egner sig til mange anledninger, grundet dens friske og frugtige
            smag, men vær opmærksom på, at alle ikke bryder sig om den markante
            bitterhed. Du kan derfor med fordel supplere din IPA med en eller
            flere fustager med klassisk pilsner eller lignende. Blandt vores
            sortiment af IPA, finder du bl.a. følgende:
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading3>Royal IPA</Heading3>
          <Paragraph>
            En skøn og frisk, humlet IPA, med fokus på balance mellem både sødme
            og bitterhed. Du vil opleve en veldefineret humlearoma og en
            alkoholprocent på 4,8%.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading3>Albani Mosaic IPA</Heading3>
          <Paragraph>
            IPA brygget med Mosaic humle, hvilket giver øllen en skøn og delikat
            fornemmelse. I den fyldige smag vil du opleve hints af både mango,
            citrus og tropefrugter, Alkoholprocent på 5,7%.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading3>Founder&apos;s All Day IPA</Heading3>
          <Paragraph>
            IPA brygget med en kompleks række af malt, korn og humle og har en
            afbalanceret og ren finish. Noter af både grape og mandarin giver
            øllen en sprød og let smagsoplevelse. Alkoholprocenten ligger på
            4,7%.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading3>Flying Cloud IPA</Heading3>
          <Paragraph>
            En overgæret IPA, brygget på de amerikanske humlesorter Amarillo og
            Cascade. Du vil opleve en fyldig smag og høj bitterhed, kombineret
            med en aroma af både mandariner, rosiner og blomster samt en
            alkoholprocent på 5,5%.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading3>Herslev Øko Grisk IPA</Heading3>
          <Paragraph>
            Denne IPA skal opleves! En spændende, velsmagende og krydret IPA,
            hvor du vil opleve smagsnuancer af fyrrenåle, grape, frisk humle og
            citrus. Alkoholprocent på 6,4%. Grisk egner sig specielt godt til
            frokost, men også grill, gris, lam og fede oste.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>En IPA er ikke bare en IPA…</Heading2>
          <Paragraph>
            Vidste du, at IPA blot er den samlede betegnelse for en type øl? Der
            findes nemlig mange forskellige slags varianter af den populære
            bryg. Nærmere bestemt findes der både en engelsk IPA, West Coast
            IPA, East Coast IPA, New England IPA, Double IPA, Triple IPA og
            Session IPA.
          </Paragraph>
          <Paragraph>
            Hos Skafte finder du et bredt udvalg af lækker IPA fadøl, og vi får
            jævnligt nye varianter i sortimentet. Skal du have lidt inspiration
            til at vælge den helt rette IPA på fad, så kan du finde nogle
            eksempler nedenfor.
          </Paragraph>
          <Paragraph>
            <Bold>New England IPA:</Bold> Dette er en forholdsvis ny slags IPA
            og næsten en videreudvikling af East Coast IPA’en. Der er tale om en
            meget uklar øl, der oftest beskrives som “hazy” og har en fyldig og
            cremet krop samt en flot skum. Ønsker du at prøve denne variant af
            IPA øl, kan du med fordel prøve Anarkist New England IPA eller
            Skands My Hazy IPA.
          </Paragraph>
          <Paragraph>
            <Bold>Double IPA:</Bold> efterhånden som efterspørgslen på IPA steg
            og steg, blev der også efterspurgt endnu kraftigere og bitre øl - og
            derfor blev Double IPA til (og senere også <Bold>Triple IPA</Bold>)
            til. Der tilsættes mere humle, hvilket er med til at give en god
            bitterhed, men denne balanceres med sødme fra ekstra malt og en
            højere alkoholprocent. Skal du prøve en Double IPA? Hvorfor så ikke
            bestille en fustage med Anarkist Juicy Galaxy IPA, der byder på en
            fyldig smag af frugter, bær og citrus - og masser af humle.
          </Paragraph>
          <Paragraph>
            <Bold>West Coast IPA:</Bold> udviklet på den amerikanske vestkyst,
            men inspireret af den <Bold>engelske IPA</Bold>, byder vestkysten på
            en mindre tør variant af IPA øllen. Den er typisk meget bitter, men
            er godt balanceret. Prøv eksempelvis Anarkist Vacation Forever, der
            byder på markant bitterhed og en let maltkarakter i baggrunden. Skal
            det være knap så bittert? Så kig efter en{" "}
            <Bold>East Coast IPA</Bold> i stedet.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>
            Bestil IPA og fadølsanlæg med hurtig levering hos Skafte
          </Heading2>
          <Paragraph>
            Kan du heller ikke vente med at lade de gyldne dråber fra IPA’en
            omfavne dine smagsløg? Så bestil allerede i dag og få leveret til
            din næste fest. Husk at du også kan leje fadølsanlæg hos Skafte og
            vi sørger for både levering, opsætning og returtagning af det hele.
            Du har også mulighed for selv at hente fra vores lager i Brøndby,
            hvis du vil spare fragten.
          </Paragraph>
          <Paragraph>
            Hvis du bestiller inden for almindelig arbejdstid, leverer Skafte
            oftest inden for 1-2 dage.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
